export const getAddressList = (addresses: AddressT[], customerId?: number) => {
  if (addresses?.length === 0) {
    return undefined;
  }
  let tmp: CustomerAddressReqT[] = [];
  addresses?.map((address: AddressT) => {
    const newItem = customerId
      ? {
          customer_id: customerId,
          id: address?.id || null,
          country_id: address?.country?.id,
          province_id: address?.province?.id,
          city_id: address?.city?.id ?? null,
          address: address?.address ?? null,
          location: address?.location ?? null,
        }
      : {
          country_id: address?.country?.id,
          province_id: address?.province?.id,
          city_id: address?.city?.id ?? null,
          address: address?.address ?? null,
        };
    tmp.push(newItem);
  });
  return tmp;
};

export const getPhoneList = (phones: PhoneT[]) => {
  if (phones?.length === 0) {
    return undefined;
  }
  let tmp: CustomerPhoneReqT[] = [];
  phones?.map((phone: PhoneT) =>
    tmp.push({ type: "" + phone?.type?.id, number: phone.number })
  );
  return tmp;
};

export const getSocialList = (socials: SocialT[]) => {
  if (socials?.length === 0) {
    return undefined;
  }
  let tmp: CustomerSocialReqT[] = [];
  socials?.map((social: SocialT) =>
    tmp.push({ type: "" + social?.type?.id, address: social.address })
  );
  return tmp;
};

export const getPostData = (obj: CustomerFormDataT, customerId?: number) => {
  let postDate: CustomerReqT = {
    name: obj?.name,
    mobile: obj?.mobile,
  };
  let shopData = {};
  let creditData = {};

  obj?.status?.id && Object.assign(postDate, { status: obj?.status?.id });
  obj?.category?.id &&
    Object.assign(postDate, { category_id: obj?.category?.id });
  Object.assign(postDate, { frindship_id: obj?.familiarityWay?.id ?? null });
  obj.coWorkers?.length > 0 &&
    Object.assign(postDate, { colleagues: obj?.coWorkers?.map((c) => c.id) });
  getAddressList(obj?.addresses) &&
    Object.assign(postDate, {
      address: getAddressList(obj?.addresses, customerId),
    });
  Object.assign(postDate, {
    characteristics: obj?.personalCharacteristics ?? null,
  });
  Object.assign(postDate, { job: obj?.role ?? null });

  Object.assign(shopData, { name: obj?.shopName ?? null });
  Object.assign(shopData, { owner_type: obj.shopOwner?.id ?? null });
  Object.assign(shopData, { area: obj?.area ?? null });
  Object.assign(shopData, { rental_period: obj?.rentalTime ?? null });
  Object.assign(shopData, { has_partner: obj?.sharer?.id ?? null });
  Object.assign(shopData, { branch: obj?.branchCount ?? null });
  Object.assign(shopData, { employee: obj?.employeeCount ?? null });
  Object.assign(shopData, { regal: obj?.regalCount ?? null });
  Object.assign(shopData, { activity_duration: obj?.workTime ?? null });
  Object.assign(shopData, { other_jobs: obj?.otherJob ?? null });
  Object.assign(shopData, { description: obj?.shopDescriptions ?? null });
  Object.assign(shopData, {
    popular_products: obj.popularProducts?.map((p) => p?.id),
  });
  Object.assign(shopData, {
    popular_categories: obj.popularCategories?.map((p) => p?.id),
  });
  Object.assign(shopData, {
    popular_attributes: obj.popularAttrs?.map((a) => ({
      attribute_id: a?.id || a?.attribute_id,
      items: a.items?.map((i) => i?.id),
    })),
  });
  Object?.keys(shopData)?.length > 0 &&
    Object?.assign(postDate, { shop: shopData });
  //? end of base info ---------------------------------------

  Object.assign(postDate, { national_code: obj?.nationalCode ?? null });
  obj?.religion &&
    Object.assign(postDate, { religion: obj?.religion?.id ?? null });
  getPhoneList(obj?.phones) &&
    Object.assign(postDate, { phone: getPhoneList(obj?.phones) });
  getSocialList(obj?.socials) &&
    Object.assign(postDate, { social: getSocialList(obj?.socials) });
  obj?.emails?.length > 0 && Object.assign(postDate, { email: obj?.emails });
  Object.assign(postDate, { website: obj?.website ?? null });
  obj?.birthday && Object.assign(postDate, { birthday: obj?.birthday });
  obj?.familiarityDate &&
    Object.assign(postDate, { friendship_at: obj?.familiarityDate });

  Object.assign(postDate, { facing_meeting: obj?.attendTimes ?? null });

  Object.assign(postDate, { description: obj?.descriptions ?? null });
  //? end of supplement info ------------------------------------------

  Object.assign(creditData, { status: obj?.customerCredit?.id ?? null });
  Object.assign(creditData, { buy_type: obj?.buyStatus?.id ?? null });
  Object.assign(creditData, { power_buy_monthly: obj?.buyAbility ?? null });
  Object.assign(creditData, {
    open_account_at: obj?.bankAccountCreationDate ?? null,
  });
  Object.assign(creditData, {
    passed_cheque_amount: obj?.maxPassedCheque ?? null,
  });
  Object.assign(creditData, {
    returned_cheque_count: obj?.bouncedChequeCount ?? null,
  });
  Object.assign(creditData, {
    search_description: obj?.creditByHerself ?? null,
  });
  Object.assign(creditData, {
    colleague_description: obj?.creditByCoWorkers ?? null,
  });
  Object.assign(creditData, { description: obj?.creditDescriptions ?? null });
  Object.keys(creditData)?.length > 0 &&
    Object.assign(postDate, { credit: creditData });

  return postDate;
};

// export const getAddressList = (addresses: AddressT[], customerId?: number) => {
//   if (addresses?.length === 0) {
//     return undefined;
//   }
//   let tmp: CustomerAddressReqT[] = [];
//   addresses?.map((address: AddressT) => {
//     const newItem = customerId
//       ? {
//           customer_id: customerId,
//           id: address?.id || null,
//           country_id: address?.country?.id,
//           province_id: address?.province?.id,
//           city_id: address?.city?.id ?? null,
//           address: address?.address ?? null,
//           location: address?.location ?? null,
//         }
//       : {
//           country_id: address?.country?.id,
//           province_id: address?.province?.id,
//           city_id: address?.city?.id ?? null,
//           address: address?.address ?? null,
//         };
//     tmp.push(newItem);
//   });
//   return tmp;
// };

// export const getPhoneList = (phones: PhoneT[]) => {
//   if (phones?.length === 0) {
//     return undefined;
//   }
//   let tmp: CustomerPhoneReqT[] = [];
//   phones?.map((phone: PhoneT) =>
//     tmp.push({ type: "" + phone?.type?.id, number: phone.number })
//   );
//   return tmp;
// };

// export const getSocialList = (socials: SocialT[]) => {
//   if (socials?.length === 0) {
//     return undefined;
//   }
//   let tmp: CustomerSocialReqT[] = [];
//   socials?.map((social: SocialT) =>
//     tmp.push({ type: "" + social?.type?.id, address: social.address })
//   );
//   return tmp;
// };

// export const getPostData = (
//   obj: CustomerFormDataT,
//   customerId?: number,
//   section?: "basic" | "extra" | "credit" | "attachment"
// ) => {
//   let postDate: CustomerReqT = {
//     name: obj?.name,
//     mobile: obj?.mobile,
//   };
//   let shopData = {};
//   let creditData = {};

//   if (section === "basic") {
//     obj?.status?.id && Object.assign(postDate, { status: obj?.status?.id });
//     obj?.category?.id &&
//       Object.assign(postDate, { category_id: obj?.category?.id });
//     Object.assign(postDate, { frindship_id: obj?.familiarityWay?.id ?? null });
//     obj.coWorkers?.length > 0 &&
//       Object.assign(postDate, { colleagues: obj?.coWorkers?.map((c) => c.id) });
//     getAddressList(obj?.addresses) &&
//       Object.assign(postDate, {
//         address: getAddressList(obj?.addresses, customerId),
//       });
//     Object.assign(postDate, {
//       characteristics: obj?.personalCharacteristics ?? null,
//     });
//     Object.assign(postDate, { job: obj?.role ?? null });

//     Object.assign(shopData, { name: obj?.shopName ?? null });
//     Object.assign(shopData, { owner_type: obj.shopOwner?.id ?? null });
//     Object.assign(shopData, { area: obj?.area ?? null });
//     Object.assign(shopData, { rental_period: obj?.rentalTime ?? null });
//     Object.assign(shopData, { has_partner: obj?.sharer?.id ?? null });
//     Object.assign(shopData, { branch: obj?.branchCount ?? null });
//     Object.assign(shopData, { employee: obj?.employeeCount ?? null });
//     Object.assign(shopData, { regal: obj?.regalCount ?? null });
//     Object.assign(shopData, { activity_duration: obj?.workTime ?? null });
//     Object.assign(shopData, { other_jobs: obj?.otherJob ?? null });
//     Object.assign(shopData, { description: obj?.shopDescriptions ?? null });
//     Object.assign(shopData, {
//       popular_products: obj.popularProducts?.map((p) => p?.id),
//     });
//     Object.assign(shopData, {
//       popular_categories: obj.popularCategories?.map((p) => p?.id),
//     });
//     Object.assign(shopData, {
//       popular_attributes: obj.popularAttrs?.map((a) => ({
//         attribute_id: a?.id || a?.attribute_id,
//         items: a.items?.map((i) => i?.id),
//       })),
//     });
//     Object?.keys(shopData)?.length > 0 &&
//       Object?.assign(postDate, { shop: shopData });
//     //? end of base info ---------------------------------------
//   } else if (section === "extra") {
//     Object.assign(postDate, { national_code: obj?.nationalCode ?? null });
//     obj?.religion &&
//       Object.assign(postDate, { religion: obj?.religion?.id ?? null });
//     getPhoneList(obj?.phones) &&
//       Object.assign(postDate, { phone: getPhoneList(obj?.phones) });
//     getSocialList(obj?.socials) &&
//       Object.assign(postDate, { social: getSocialList(obj?.socials) });
//     obj?.emails?.length > 0 && Object.assign(postDate, { email: obj?.emails });
//     Object.assign(postDate, { website: obj?.website ?? null });
//     obj?.birthday && Object.assign(postDate, { birthday: obj?.birthday });
//     obj?.familiarityDate &&
//       Object.assign(postDate, { friendship_at: obj?.familiarityDate });

//     Object.assign(postDate, { facing_meeting: obj?.attendTimes ?? null });

//     Object.assign(postDate, { description: obj?.descriptions ?? null });
//     //? end of supplement info ------------------------------------------
//   } else if (section === "credit") {
//     Object.assign(creditData, { status: obj?.customerCredit?.id ?? null });
//     Object.assign(creditData, { buy_type: obj?.buyStatus?.id ?? null });
//     Object.assign(creditData, { power_buy_monthly: obj?.buyAbility ?? null });
//     Object.assign(creditData, {
//       open_account_at: obj?.bankAccountCreationDate ?? null,
//     });
//     Object.assign(creditData, {
//       passed_cheque_amount: obj?.maxPassedCheque ?? null,
//     });
//     Object.assign(creditData, {
//       returned_cheque_count: obj?.bouncedChequeCount ?? null,
//     });
//     Object.assign(creditData, {
//       search_description: obj?.creditByHerself ?? null,
//     });
//     Object.assign(creditData, {
//       colleague_description: obj?.creditByCoWorkers ?? null,
//     });
//     Object.assign(creditData, { description: obj?.creditDescriptions ?? null });
//     Object.keys(creditData)?.length > 0 &&
//       Object.assign(postDate, { credit: creditData });
//   }

//   return postDate;
// };
